import { apiFetch } from '@/lib/api';

/** Label sent when the Mac session read-back card creates its token. */
export const MAC_SESSION_READBACK_LABEL = 'Mac session read-back';

export interface CreatedTenantApiToken {
  id: string;
  label: string;
  token_prefix: string;
  secret: string;
  created_at: string;
}

/** List and revoke payloads. The server never includes the secret here. */
export interface TenantApiTokenMetadata {
  id: string;
  label: string;
  token_prefix: string;
  last_used_at: string | null;
  created_at: string;
  revoked_at: string | null;
  active: boolean;
}

const BASE = '/api/v1/providers/api-tokens';

export function listTenantApiTokens(): Promise<{ tokens: TenantApiTokenMetadata[] }> {
  return apiFetch(`${BASE}/`);
}

export function createTenantApiToken(label: string): Promise<CreatedTenantApiToken> {
  return apiFetch(`${BASE}/`, {
    method: 'POST',
    body: JSON.stringify({ label }),
  });
}

export function revokeTenantApiToken(tokenId: string): Promise<TenantApiTokenMetadata> {
  return apiFetch(`${BASE}/${encodeURIComponent(tokenId)}`, {
    method: 'DELETE',
  });
}
